import ApiEditPage from './Api/Edit/index';
import ApplicationEditPage from './Application/Edit';
import ApplicationDetailsPage from './Application/Details';
import ApiProxyEditPage from './ApiProxy/Edit';
import ApiProxyDetailsPage from './ApiProxy/Details';
import GatewayBundleDetailsPage from './GatewayBundle/Details';
import GatewayBundleListPage from './GatewayBundle/List';
import OrganizationListPage from './Organization/List';
import OrganizationEditPage from './Organization/Edit';
import GatewayBundleEditPage from './GatewayBundle/Edit';
import ProxyDetailsPage from './Proxy/Details';
import UserListPage from './User/List';
import PageNotFoundPage from './PageNotFoundPage';

export {
  ApiEditPage,
  ApplicationEditPage,
  ApplicationDetailsPage,
  ApiProxyEditPage,
  ApiProxyDetailsPage,
  GatewayBundleDetailsPage,
  GatewayBundleListPage,
  GatewayBundleEditPage,
  OrganizationListPage,
  OrganizationEditPage,
  ProxyDetailsPage,
  UserListPage,
  PageNotFoundPage,
};



// WEBPACK FOOTER //
// ./src/pages/index.js